import { Icon, IconProps } from ".";

export const InfosIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4444 4H7.55556V5.77778H5.77778V7.55556H4V16.4444H5.77778V18.2222H7.55556V20H16.4444V18.2222H18.2222V16.4444H20V7.55556H18.2222V5.77778H16.4444V4ZM11 8V10H13V8H11ZM13 11V15H14V16H10V15H11V12H10V11H13Z"
        fill="currentColor"
      />
    </Icon>
  );
};
